import React from 'react';
import PropTypes from 'prop-types';
import PullDownIcon from 'zignal-landscape/lib/Icon/PullDownIcon';
import PullUpIcon from 'zignal-landscape/lib/Icon/PullUpIcon';
import classNames from 'classnames/bind';
import styles from './Drawer.css';
import isEmpty from 'lodash/isEmpty';

const cx = classNames.bind(styles);

export default function Drawer({children, header, isOpen, ...other}) {
  const ignoreClick = (e) => e.stopPropagation();

  const showHandle = !isEmpty(children);
  const handleStyle = cx({
    drawerHandle: true,
    drawerHandleOpen: isOpen
  });

  const handle = (<div className={handleStyle}>
    {isOpen ? <PullDownIcon width="0.5em" height="0.5em" /> : <PullUpIcon width="0.5em" height="0.5em" />}
  </div>);
  let drawerChildren = null;
  if (showHandle) {
    drawerChildren = React.Children.map(children, (child) => (
      <div className={styles.drawerChildContainer}>{child}</div>
    ));
  }

  return (
    <div {...other} className={styles.drawerContainer}>
      {showHandle? handle : null}
      <ul className={styles.drawerChildrenContainer} onClick={ignoreClick}>
        {isOpen ? drawerChildren : null}
      </ul>
      <div className={styles.drawerHeader}>{header}</div>
    </div>
  );
}

Drawer.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func
};
